import React, { useEffect, useState } from 'react'
import axios from 'axios';
import maticIcon from "../assets/images/maticIcon.svg";
import eye from "../assets/images/eye.svg";
import like from "../assets/images/like.svg";
import Currency from './Currency/Currency';
const NftCard = ({ item }) => {
      const [convertIntoCurrency, setConvertIntoCurrency] = useState("USD")
      const [symbol, setSymbol] = useState("$");
      const [usdPrices, setUsdPrices] = useState()
      const setCurrnencyTobeConverted = (currency, symbol) => {
        setConvertIntoCurrency(currency)
        setSymbol(symbol)
      }

    const setUsdPriceFunc = async (symbol, price) => {
        let amount = Number(price);
        let data = await converCryptoToDollar(amount, symbol, convertIntoCurrency);
        setUsdPrices(Number(data))
    };

    useEffect(()=>{setUsdPriceFunc(symbol, item.price)},[symbol, item,convertIntoCurrency])



    return (

        <div className="trandingArt">
            <div className="imgBox" onClick={() => window.open(`https://market.terpnash.com/nftsale/${item?._id}`, '_blank')}
                style={{ cursor: 'pointer' }}>
                <div className="artistNameBox">
                    <img src={item?.owner_id?.profileImage?.link} alt="" /><h5>{item?.owner_id?.name + " " + item?.owner_id?.lastname}</h5>
                </div>
                <img src={item?.nft_id?.image_id?.image?.water_mark_image_link} alt="" />
            </div>
            <div className="contentBox">
                <h3 title="Rhythms Of Nature">{item?.nft_id?.name}</h3>
                <div className="artPriceBox">
                    <div>
                        {/* <div className="artRate">
                            <h4>{item?.price}</h4>
                            <img src={maticIcon} width={30} height={30} alt="" />
                        </div> */}
                        <div className="artRate">
                            <h4 className='d-block'>
                                {symbol +" "+usdPrices}
                            </h4>
                            
                                <Currency setCurrnencyTobeConverted={setCurrnencyTobeConverted} />
                        
                        </div>
                    </div>
                    <ul>
                        <li className="d-flex gap-2 align-items-center">
                            <img src={eye} width={25} height={25} alt="" className="mt-1" />
                            <h5>{item?.view_count}</h5>
                        </li>
                        <li className="d-flex gap-2 align-items-center">
                            <img src={like} width={25} height={25} alt="" className="mt-1" />
                            <h5>{item?.like_count}</h5>
                        </li>
                    </ul>
                </div>
                <button className="exploreBtn mt-3" onClick={() => window.open(`https://market.terpnash.com/nftsale/${item?._id}`, '_blank')}>Explore Now</button>
            </div>
        </div>
    )
}

export default NftCard



const converCryptoToDollar = async (
    amount,
    symbol,
    currency = "USD"
) => {
    let calculatedAmount = 0;
    try {
        if (amount && symbol) {
            const response = await axios.get(
                `https://min-api.cryptocompare.com/data/price?fsym=MATIC&tsyms=${currency}`
            );
            calculatedAmount = response.data[currency]
                ? response.data[currency] * amount
                : 0;


            console.log("thisistheresponse", response)
            return calculatedAmount ? Number(calculatedAmount).toFixed(5) : 0;
        } else {
            return 0;
        }
    } catch (error) {
        console.log(error, "USDErrorFound!!");
        return 0;
    }
};